import React from 'react'
import Img from 'gatsby-image'
import styles from './LogoBanner.module.css'

export default ({ data }) => (
  <div className={styles.logoBanner}>
    {[
      {
        logo: data.logoBannerSlice0,
        href: 'https://www.bmnt.gv.at/land/laendl_entwicklung.html',
      },
      {
        logo: data.logoBannerSlice1,
        href: 'https://www.bmnt.gv.at/land/laendl_entwicklung.html',
      },
      {
        logo: data.logoBannerSlice2,
        href:
          'https://www.burgenland.at/natur-umwelt-agrar/foerderungen/laendliche-entwicklung-2014-2020/',
      },
      {
        logo: data.logoBannerSlice3,
        href: 'https://ec.europa.eu/agriculture/rural-development-2014-2020_de',
      },
    ].map(({ logo, href }, i) => (
      <div key={i} style={{ width: logo.original.width / 2 }}>
        <a href={href}>
          <Img sizes={logo.sizes} />
        </a>
      </div>
    ))}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/LogoBanner.js